import axios from "axios";
import React, { useContext, useEffect, useReducer } from "react";
import reducer from "../reducers/season_division_reducer";
import { group_detail_url } from "../utils/constants";
import {
  SEASON_GRP_LOADING_IN_PROGRESS,
  SEASON_GRP_LOADING_ERROR,
  SEASON_GRP_LOADING_COMPLETED,
  SEASON_GRP_UPDATED,
} from "../actions";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

const initialState = {
  season: 5,
  divisionId: null,
  divisionPlayers: [],
  seasonGrpInProgress: false,
  seasonGrpError: false,
  seasonGrpCompleted: false,
};

const SeasonDivision = React.createContext();

export const SeasonDivisionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchSeasonDivision = async () => {
    if (!state.divisionId || !state.season) {
      return;
    }
    const url = group_detail_url
      .replace("$SEASON_ID", state.season)
      .replace("$DIVISION_ID", state.divisionId);

    const url_details = group_detail_url.replace(
      "$DIVISION_ID",
      state.divisionId
    );

    dispatch({ type: SEASON_GRP_LOADING_IN_PROGRESS });

    try {
      const response = await axios.get(url);
      const seasonDivision = response.data;

      const response_details = await axios.get(url_details, {
        validateStatus: false,
      });
      if (response_details.status === 200) {
        seasonDivision.details = response_details.data;
      } else {
        console.log(`No details for the division ${state.divisionId}`);
      }

      dispatch({ type: SEASON_GRP_LOADING_COMPLETED, payload: seasonDivision });
    } catch (error) {
      console.log(`Error getting division info`);
      dispatch({ type: SEASON_GRP_LOADING_ERROR });
    }
  };

  const updateDivisionId = (divisionId) => {
    dispatch({ type: SEASON_GRP_UPDATED, payload: { divisionId: divisionId } });
  };

  useEffect(() => {
    fetchSeasonDivision();
    // eslint-disable-next-line
  }, [state.divisionId]);

  return (
    <SeasonDivision.Provider
      value={{ ...state, fetchSeasonDivision, updateDivisionId }}
    >
      {children}
    </SeasonDivision.Provider>
  );
};
// make sure use
export const useSeasonDivisionContext = () => {
  return useContext(SeasonDivision);
};
